<div class="frac-fctv-add">
  <form [formGroup]="addNewForm" *ngIf="!(contractManagement$$ | async)" (ngSubmit)="addFctv()">
    <div class="details col">
      <h4>Trucking Vendor</h4>
      <sa-filtered-autocomplete
        formControlName="vendor"
        [groupedSelectOptions]="vendors$ | async"
        [displayFn]="vendorDisplayFn"
        placeholderText="Select Vendor"
        saAutomatedSelector="fctv_add__vendor"
      ></sa-filtered-autocomplete>
      <h4>Contract</h4>
      <div class="contract-container">
        <sa-filtered-autocomplete
          [formControl]="contractForm"
          [selectOptions]="vendorContracts$ | async"
          [displayFn]="vendorDisplayFn"
          placeholderText="Select Contract"
          [disableButton]="addNewForm.get('vendor').invalid"
          saAutomatedSelector="fctv_add__contract"
        ></sa-filtered-autocomplete>
        <ng-container *saUserPermission="'trucking_contract_manager'">
          <button
            type="button"
            color="primary"
            mat-mini-fab
            (click)="createNewContract()"
            [disabled]="addNewForm.get('vendor').invalid"
          >
            <mat-icon>add</mat-icon>
          </button>
        </ng-container>
      </div>
      <h4>Job Details</h4>
      <div class="job-details">
        <mat-form-field class="form-field">
          <input
            matInput
            class="datepicker-input"
            placeholder="Valid Dates"
            autocomplete="off"
            formControlName="dates"
            [owlDateTime]="dates"
            [owlDateTimeTrigger]="dates"
            [selectMode]="'range'"
            [max]="maxDate"
            saAutomatedSelector="fctv_add__dates"
          />
          <span [owlDateTimeTrigger]="dates"><i class="material-icons">calendar_today</i></span>
          <owl-date-time #dates [pickerType]="'calendar'"></owl-date-time>
        </mat-form-field>
        <mat-form-field class="form-field">
          <textarea
            matInput
            placeholder="Description"
            autocomplete="off"
            formControlName="description"
            saAutomatedSelector="fctv_add__description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>
    <div class="distribution col">
      <h4>Work Distribution</h4>
      <ng-container
        *ngFor="
          let distribution of distributions.controls;
          let i = index;
          trackBy: distributions.controls | trackByKey: null
        "
        formArrayName="distributions"
      >
        <div class="vendor-distribution" [formGroupName]="i">
          <span class="vendor-name">{{
            getVendorNameFromId$(distribution.get('fracClusterTruckingVendorId').value) | async
          }}</span>
          <mat-form-field>
            <input
              matInput
              type="number"
              placeholder="Percent"
              formControlName="allocationPercent"
              autocomplete="off"
              saAutomatedSelector="fctv_add__distribution"
              [automatedName]="getVendorNameFromId$(distribution.get('fracClusterTruckingVendorId').value) | async"
            />
          </mat-form-field>
        </div>
      </ng-container>
      <button class="submit" mat-raised-button color="primary" type="submit" saAutomatedSelector="fctv_add__submit">
        Send To Vendor
      </button>
    </div>
  </form>
  <div class="contract-management" *ngIf="contractManagement$$ | async">
    <button mat-icon-button (click)="cancelContractChoice()"><mat-icon>close</mat-icon></button>
    <h3>Vendor Contract</h3>
    <sa-lmo-frac-fctv-contract-addedit
      [contract]="contractForm.value"
      [vendor]="addNewForm.get('vendor').value"
      [formControl]="addNewForm.get('contract')"
    ></sa-lmo-frac-fctv-contract-addedit>
  </div>
</div>

<ng-template #addVendor>
  <button class="close-button" mat-icon-button [mat-dialog-close]="false"><mat-icon>close</mat-icon></button>
  <ng-container *ngIf="addNewFormValue.vendor as vendor">
    <div class="details">
      <h4>Vendor Details</h4>
      <h3>{{ vendor.name }}</h3>
      <div class="key-value-line">
        <span class="key">Rating:</span>
        <span class="value">{{ vendor.isnRating }}</span>
      </div>
      <div class="key-value-line">
        <span class="key">Active In:</span>
        <span class="value">{{ (vendor.activeStates || []).join(', ') }}</span>
      </div>
      <div class="key-value-line">
        <span class="key">{{ vendor.numberOfDrivers | i18nPlural: driverPluralMapping }}</span>
      </div>
      <div class="key-value-line">
        <span class="key">Assets:</span>
        <span class="value">{{ (vendor.assetTypes || []).join(', ') }}</span>
      </div>
      <div class="updated-at">Updated {{ vendor.updatedTimestamp | ago }}</div>
    </div>
    <mat-divider></mat-divider>
    <div class="actions">
      <button mat-button color="primary" mat-dialog-close="add">Add To Network</button>
      <button mat-button color="primary" mat-dialog-close="request-contact">Request Contact</button>
    </div>
    <div class="description">
      <h4>Description</h4>
      <p>{{ vendor.description ? vendor.description : ' No Description Provided' }}</p>
    </div>
  </ng-container>
  <div class="disclaimer">
    ShaleApps is in no way endorsed, sponsored, approved by, or otherwise affiliated with ISNetworld&reg;
  </div>
</ng-template>
